var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2ZM10.6348 6.08008C10.4027 5.86744 10.0428 5.88321 9.83008 6.11523L7.46582 8.69336L6.13672 7.46582C5.9054 7.2523 5.54458 7.26673 5.33105 7.49805C5.11761 7.72937 5.13199 8.09021 5.36328 8.30371L7.11328 9.91895C7.22454 10.0216 7.37217 10.0756 7.52344 10.0693C7.67482 10.063 7.81754 9.99646 7.91992 9.88477L10.6699 6.88477C10.8826 6.6527 10.8668 6.29277 10.6348 6.08008Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark2);
export default __webpack_public_path__ + "static/media/Checkmark2.af20fcacafee26c75517a9d9e67fc04b.svg";
export { ForwardRef as ReactComponent };